import { Inbox } from '@novu/react'
import { useAppStore, useLocalStore } from '../stores'
import { config } from '../shared'
import { dark } from '@novu/react/themes'

type Props = { children: React.ReactNode }

export const NovuProvider = ({ ...props }: Props) => {
  const currentUser = useAppStore((state) => state.currentUser)

  const theme = useLocalStore((s) => s.theme)
  const preferredTheme =
    theme === 'auto' ? (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light') : theme

  return (
    <Inbox
      applicationIdentifier={config.novuAppId}
      subscriber={currentUser?.id ?? ''}
      appearance={{
        baseTheme: preferredTheme === 'dark' ? dark : undefined,
        elements: {
          dropdownContent: 'p-2',
          dropdownItem: 'p-2',
          channelsContainer: 'gap-3',
          notificationBody: 'text-neutral-900 font-medium text-xs',
        },
        variables: { colorPrimary: '#0090FF' },
      }}
      {...props}
    />
  )
}
